<script lang="ts" setup>
const props = defineProps<{ isOpen: boolean, class?: string }>()
</script>

<template>
  <teleport to="body">
    <div ref="wrapper"
         class="ui-modal fixed w-full overflow-hidden transition-transform duration-400 ease-in-out flex flex-col top-0 left-0 h-full"
         :class="[!props.isOpen ? 'translate-y-full': '-translate-y-0', props.class ?? '']">
      <slot v-if="props.isOpen"/>
    </div>
  </teleport>
</template>
